<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="21"
    viewBox="0 0 41 21"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.6057 0.133545C22.6207 0.133545 21.8223 0.932017 21.8223 1.91698V17.3252C21.8223 18.3102 22.6207 19.1087 23.6057 19.1087H26.3949C27.3799 19.1087 28.1783 18.3102 28.1783 17.3252V1.91699C28.1783 0.932019 27.3799 0.133545 26.3949 0.133545H23.6057ZM15.1133 6.83617C15.1133 5.85121 15.9118 5.05273 16.8967 5.05273H19.6859C20.6709 5.05273 21.4693 5.85121 21.4693 6.83618V17.325C21.4693 18.3099 20.6709 19.1084 19.6859 19.1084H16.8967C15.9118 19.1084 15.1133 18.3099 15.1133 17.3249V6.83617ZM8.4043 12.4586C8.4043 11.4736 9.20277 10.6752 10.1877 10.6752H12.9769C13.9619 10.6752 14.7604 11.4736 14.7604 12.4586V16.8235C14.7604 18.1297 13.4023 18.9928 12.2197 18.4382L9.43048 17.1301C8.80424 16.8364 8.4043 16.2071 8.4043 15.5154V12.4586Z"
      fill="#F8961E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.6057 0.133545C22.6207 0.133545 21.8223 0.932017 21.8223 1.91698V17.3252C21.8223 18.3102 22.6207 19.1087 23.6057 19.1087H26.3949C27.3799 19.1087 28.1783 18.3102 28.1783 17.3252V1.91699C28.1783 0.932019 27.3799 0.133545 26.3949 0.133545H23.6057ZM15.1133 6.83617C15.1133 5.85121 15.9118 5.05273 16.8967 5.05273H19.6859C20.6709 5.05273 21.4693 5.85121 21.4693 6.83618V17.325C21.4693 18.3099 20.6709 19.1084 19.6859 19.1084H16.8967C15.9118 19.1084 15.1133 18.3099 15.1133 17.3249V6.83617ZM8.4043 12.4586C8.4043 11.4736 9.20277 10.6752 10.1877 10.6752H12.9769C13.9619 10.6752 14.7604 11.4736 14.7604 12.4586V16.8235C14.7604 18.1297 13.4023 18.9928 12.2197 18.4382L9.43048 17.1301C8.80424 16.8364 8.4043 16.2071 8.4043 15.5154V12.4586Z"
      fill="#F8961E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.5498 10.3708L24.9434 7.57014L38.474 6.98206L40.0431 17.0149L36.4165 14.7855C24.3735 25.5092 7.0819 21.0612 0.0608256 7.59327C7.59507 17.7566 20.4207 20.8212 29.5498 10.3708Z"
      fill="#482BD9"
    />
  </svg>
</template>
